import React, {Component, Suspense, lazy} from 'react';
import {__DEVELOPMENT__} from '~/utils/env';
import Cookies from 'cookies-js';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {matchPath} from 'react-router-dom';
import values from 'lodash/values';
import {actions, select} from './connectors';
import MediaQuery from 'react-responsive';
const App = lazy(() => import('~/components/App'), 'App');
const App_Lg = lazy(() => import('~/components/App_Lg'), 'App_Lg');
// constants and utils
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
import MediaQueries, {breakpoint} from '~/constants/MediaQueries';
import ApiConstants from '~/constants/ApiConstants';
import {
  DEBOSS_DESIGN_TIPS,
  EMBOSS_DESIGN_TIPS,
  LASER_ENGRAVING_DESIGN_TIPS
} from '~/constants/NotificationConstants';
import * as WelcomeConstants from '~/constants/WelcomeConstants';
import remoteServices from '~/constants/RemoteServices';
import {
  SELECTED_ICON_PATH_WHITELIST,
  ALLOWED_ON_LOAD_PATHS
} from '~/constants/RouterConstants';
import {
  DEFAULT_STYLE_ID,
  HANES_TAGLESS,
  HANES_ESSENTIAL,
  DEFAULT_BLANK_PRODUCT
} from '~/constants/ProductConstants';
import {INTERNAL_USER_FLAG, isEligibleForStreamlinedMobile} from '~/utils/user';
import {
  addArtPresent,
  addComplementaryStylesPresent,
  buyNowPresent,
  catalogPresent,
  designParamsPresent,
  uploadParamsPresent,
  fundraisingOriginParam,
  getCompositeId,
  getDesignParams,
  getUploadParams,
  getKeyword,
  getStreamlinedMobileParam,
  getExternalUserParam,
  getInternalUserParam,
  keywordPresent,
  orderOptionsPresent,
  preferSingles,
  productParamsPresent,
  showProductColorPresent,
  getSelectIntoTestParam,
  getQuantitiesParams,
  quantityParamsPresent,
  openUploadPresent
} from '~/utils/url';
import {signal} from 'signalerjs-react';
import signaler from '~/vendor/signaler';
import {buildUrl} from '~/utils/url';
import {metrics} from '~/vendor/metrics';
import withRouter, {routerPropTypes} from '~/router/withRouter';

import {getProfilesSignalmanFeature} from '~/utils/signalman.js';
import {collaborationFlag} from '~/selectors/ConfigSelectors';
import {PigmentThemeProvider} from '@customink/pigment-react';
import EmbroideryModal from '../EmbroideryModal';
import FullPageDropzone from '../UploadDropzone/FullPageDropzone';

signaler.featureFlag('defaultBlank_v9');
// For selecting into using query params
const SIGNALMAN_FLAGS = new Set([collaborationFlag]);

const mapSignalsToProps = (signals, ownProps) => {
  return {defaultBlank: signals.defaultBlank_v9, signals: signals, ...ownProps};
};

const propTypes = {
  loadStyles: PropTypes.func.isRequired,
  addSignals: PropTypes.func,
  allStylesLoaded: PropTypes.bool,
  anchorStyle: PropTypes.object,
  anchorStyleId: PropTypes.string,
  currentColorId: PropTypes.string,
  defaultBlank: PropTypes.string,
  deselectAllIcons: PropTypes.func,
  didSelectedStyleLoadError: PropTypes.bool,
  enableSleeveNav: PropTypes.func,
  fetchingDesign: PropTypes.bool,
  fireNoDesignAnalytics: PropTypes.func,
  getCart: PropTypes.func,
  getUploadFile: PropTypes.func,
  hooks: PropTypes.object,
  isAnchorDebossed: PropTypes.bool,
  isAnchorEmbossed: PropTypes.bool,
  isAnchorEmbroidered: PropTypes.bool,
  isAnchorLaserEngraved: PropTypes.bool,
  isDirty: PropTypes.bool,
  isDragNDropAnywhereEnabled: PropTypes.bool,
  isMultiItemEligible: PropTypes.bool,
  isStreamlinedMobileMode: PropTypes.bool,
  loadCartCookie: PropTypes.func,
  loadDesign: PropTypes.func,
  loadFontAutofillData: PropTypes.func,
  loadInitialDesign: PropTypes.func,
  loadStyleVariants: PropTypes.func,
  meta: PropTypes.objectOf(PropTypes.func),
  prompt: PropTypes.func,
  replaceProductsCartMode: PropTypes.func,
  router: routerPropTypes,
  selectedStyles: PropTypes.arrayOf(PropTypes.string),
  selectIcon: PropTypes.func,
  setCartMode: PropTypes.func,
  setDefaultProductForAD: PropTypes.func,
  setLabBlankLoad: PropTypes.func,
  setOrderOptionsPath: PropTypes.func,
  setPreferSingles: PropTypes.func,
  setStreamlinedMobileIntent: PropTypes.func,
  setStreamlinedMobileMode: PropTypes.func,
  signals: PropTypes.object,
  simplePricingTestEnabled: PropTypes.bool,
  streamlinedMobileIntent: PropTypes.string,
  swapProduct: PropTypes.func,
  updateInternalUser: PropTypes.func,
  updateProductQuantities: PropTypes.func,
  updateSleevePrintOverride: PropTypes.func,
  updateStylesCategoryPaths: PropTypes.func,
  upload: PropTypes.func,
  validateActiveProducts: PropTypes.func,
  welcomeStage: PropTypes.oneOf(values(WelcomeConstants)),
  wtoTestEnabled: PropTypes.bool,
  onWillMount: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class AppContainer extends Component {
  static displayName = 'AppContainer';
  static propTypes = propTypes;

  static defaultProps = {
    enableSleeveNav() {},
    loadFontAutofillData() {},
    isStreamlinedMobileMode: null,
    loadCartCookie() {},
    loadStyleVariants() {},
    meta: {
      ndxStart() {},
      welcome() {},
      loadWithoutDesign() {},
      welcomeBack() {},
      orderMore() {},
      orderMoreAddStyles() {},
      fireAdSwapClipartTags() {},
      defaultBlankTest() {}
    },
    onWillMount() {},
    replaceProductsCartMode() {},
    setCartMode() {},
    setLabBlankLoad() {},
    signals: {}
  };

  constructor(props) {
    super(props);
    this.state = {
      isEmbroideryModalOpen: false
    };
  }

  UNSAFE_componentWillMount() {
    this.props.onWillMount();
    this.props.setPreferSingles(preferSingles());

    const streamlinedMobileTest = getStreamlinedMobileParam();

    this.setUserType();

    if (orderOptionsPresent()) {
      this.props.hooks.setNavigateTo('/next');
    } else if (buyNowPresent()) {
      metrics.pageViewTag('/ndx/start/buynow');
      this.props.hooks.setNavigateTo('/next/buy');
    } else if (openUploadPresent()) {
      this.props.hooks.setNavigateTo('/uploadForm');
    } else if (catalogPresent()) {
      this.props.hooks.setNavigateTo('/productCatalog');
    } else if (addComplementaryStylesPresent()) {
      this.props.hooks.setNavigateTo('/addItems');
    } else if (keywordPresent()) {
      this.props.hooks.setNavigateTo(`/searchArt/'${getKeyword()}'`);
    } else if (addArtPresent()) {
      this.props.hooks.setNavigateTo('/addArt');
    } else {
      if (orderOptionsPresent()) {
        this.props.hooks.setNavigateTo('/next');
      } else {
        this.showWelcome();
      }
    }

    if (fundraisingOriginParam() === 'navigation') {
      this.props.meta.fundraisingNavigationPageview();
    }

    if (fundraisingOriginParam() === 'campaign_closed') {
      this.props.meta.fundraisingCampaignClosedPageview();
    }

    if (streamlinedMobileTest) {
      this.props.setStreamlinedMobileMode(true);
      this.props.setStreamlinedMobileIntent(getStreamlinedMobileParam());
    }

    const signals = this.props.signals;

    const selectedTests = getSelectIntoTestParam();

    // only take tests that exist in signals
    const mergeExisting = (obj1, obj2) =>
      Object.keys(obj2).forEach(key => {
        if (key in obj1 || SIGNALMAN_FLAGS.has(key)) {
          obj1[key] = obj2[key];
        }
      });

    Object.keys(selectedTests).map(key => {
      signaler.setFeatureFlag(key, selectedTests[key]);
    });

    mergeExisting(signals, selectedTests);

    this.props.addSignals(signals);

    getProfilesSignalmanFeature(collaborationFlag).then(flagValue => {
      if (!selectedTests[collaborationFlag]) {
        this.props.addSignals({[collaborationFlag]: flagValue});
      }
    });

    if (!this.props.fetchingDesign) {
      this.props.meta.loadWithoutDesign();
    }
  }

  componentDidMount() {
    const {setLabBlankLoad, loadFontAutofillData, getCart} = this.props;
    this.requestDataForStore();
    this.setQuantities();
    this.collectWelcomeMetrics();
    setLabBlankLoad(!getCompositeId());
    loadFontAutofillData();
    getCart();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const isDoneFetchingDesign =
      this.props.fetchingDesign && !nextProps.fetchingDesign;
    const shouldAttemptStyleLoad =
      !nextProps.allStylesLoaded && !nextProps.didSelectedStyleLoadError;
    if (isDoneFetchingDesign || shouldAttemptStyleLoad) {
      this.loadStyleData(nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    this.props.enableSleeveNav();
    this.deselectAllIconsForNonWhitelistedPath();
    this.showProductTypeTipNotification(prevProps.anchorStyle?.id);
    if (this.props.wtoTestEnabled) {
      this.props.setOrderOptionsPath('/next/quote');
    }
  }

  openEmbroideryModal = () => {
    if (sessionStorage.getItem('embroideryModalOpened') === 'true') {
      return;
    }

    this.setState({isEmbroideryModalOpen: true});
    sessionStorage.setItem('embroideryModalOpened', 'true');
  };

  handleCloseEmbroideryModal = () => {
    this.setState({isEmbroideryModalOpen: false});
  };

  deselectAllIconsForNonWhitelistedPath() {
    const {
      deselectAllIcons,
      router: {location}
    } = this.props;

    if (
      SELECTED_ICON_PATH_WHITELIST.every(
        okayPath => !okayPath.test(location.pathname)
      )
    ) {
      deselectAllIcons();
    }
  }

  showProductTypeTipNotification(prevAnchorStyleId) {
    const {
      isAnchorDebossed,
      isAnchorEmbossed,
      isAnchorEmbroidered,
      isAnchorLaserEngraved,
      anchorStyle
    } = this.props;

    if (prevAnchorStyleId !== anchorStyle?.id) {
      if (isAnchorEmbroidered) {
        this.openEmbroideryModal();
      } else if (isAnchorLaserEngraved) {
        this.props.prompt({key: LASER_ENGRAVING_DESIGN_TIPS});
      } else if (isAnchorDebossed) {
        this.props.prompt({key: DEBOSS_DESIGN_TIPS});
      } else if (isAnchorEmbossed) {
        this.props.prompt({key: EMBOSS_DESIGN_TIPS});
      }
    }
  }

  isTestEnabled = flagName => this.props.signals[flagName] === 'test';

  setUserType() {
    if (getExternalUserParam()) {
      // Check first external is set explicitly in URL params
      this.props.updateInternalUser('external');
    } else if (getInternalUserParam()) {
      // Check first if internal is set explicitly in URL params
      this.props.updateInternalUser('internal');
    } else if (Cookies.get(INTERNAL_USER_FLAG) === 'false') {
      // Check if external is set in Cookies
      this.props.updateInternalUser('external');
    } else if (Cookies.get(INTERNAL_USER_FLAG) === 'true') {
      // Check if internal is set in Cookies
      this.props.updateInternalUser('internal');
    }
  }

  setDefaultBlank() {
    const {anchorStyleId, currentColorId} = this.props;

    const swapProductDefaultOptionsLabLoad = (
      previousColorId,
      previousStyleId,
      nextProduct
    ) => {
      if (previousStyleId !== nextProduct.styleId) {
        this.props.swapProduct({
          previousColorId,
          previousStyleId,
          nextProduct,
          isAD: false,
          clearMismatchedViews: false,
          clearSizeDropWarning: false,
          clearPreviousProducts: true,
          isSwappingEmbroidToPrintVariant: false,
          isInitialLabLoad: true,
          redoUndoable: false
        });
      }
    };

    if (
      !this.props.selectedStyles.includes(HANES_ESSENTIAL.styleId) &&
      this.props.defaultBlank === HANES_ESSENTIAL.flagName
    ) {
      swapProductDefaultOptionsLabLoad(
        anchorStyleId,
        currentColorId,
        HANES_ESSENTIAL
      );
    } else if (
      !this.props.selectedStyles.includes(HANES_TAGLESS.styleId) &&
      this.props.defaultBlank === HANES_TAGLESS.flagName
    ) {
      swapProductDefaultOptionsLabLoad(
        anchorStyleId,
        currentColorId,
        HANES_TAGLESS
      );
    } else {
      swapProductDefaultOptionsLabLoad(
        anchorStyleId,
        currentColorId,
        DEFAULT_BLANK_PRODUCT
      );
    }
  }

  isEligibleForStreamlinedMobile = isEligibleForStreamlinedMobile();

  collectWelcomeMetrics() {
    if (this.props.welcomeStage === WelcomeConstants.WELCOME) {
      this.props.meta.welcome();
    } else if (this.props.welcomeStage === WelcomeConstants.WELCOME_BACK) {
      this.props.meta.welcomeBack();
    }
  }

  requestDataForStore() {
    if (designParamsPresent() && productParamsPresent()) {
      this.props.loadDesign({...getDesignParams(), autoSelectProduct: false});
    } else if (designParamsPresent()) {
      this.props.loadDesign(getDesignParams());
    } else {
      this.loadStyleData();
    }

    if (uploadParamsPresent()) {
      this.loadUploadFromQueryString(getUploadParams());
    }
  }

  setQuantities() {
    if (quantityParamsPresent()) {
      const sizes = getQuantitiesParams();
      const quantities = {[this.props.currentColorId]: sizes};
      this.props.updateProductQuantities(quantities);
    }
  }

  loadStyleData(props = this.props) {
    var styles = props.selectedStyles;

    if (this.isNewDesign()) {
      if (props.defaultBlank === HANES_ESSENTIAL.flagName) {
        styles = [DEFAULT_STYLE_ID, HANES_ESSENTIAL.styleId];
        props.meta.defaultBlankTest({flag: 'test'});
      } else if (props.defaultBlank === HANES_TAGLESS.flagName) {
        styles = [DEFAULT_STYLE_ID, HANES_TAGLESS.styleId];
        props.meta.defaultBlankTest({flag: 'control'});
      } else {
        styles = [DEFAULT_STYLE_ID, DEFAULT_BLANK_PRODUCT.styleId];
        props.meta.defaultBlankTest({flag: 'excluded'});
      }
    }

    this.loadSelectedStyles(styles);
  }

  isNewDesign() {
    return (
      !this.props.isDirty && !designParamsPresent() && !productParamsPresent()
    );
  }

  overrideDefaultBlank() {
    return this.isNewDesign();
  }

  loadStylesWrapper(styles, props = this.props, callbackFunc = () => {}) {
    props.loadStyles(styles, true, true).then(_ => {
      this.overrideDefaultBlank() && this.setDefaultBlank();
      callbackFunc();
      const isValidProducts = props.validateActiveProducts();
      if (!isValidProducts) {
        this.handleCloseEmbroideryModal();
      }
      props.meta.ndxStart();
      props.updateStylesCategoryPaths(styles);
      props.loadStyleVariants(styles);
    });
  }

  loadSelectedStyles(styles, props = this.props) {
    this.loadStylesWrapper(styles, props, () => {
      props.updateSleevePrintOverride();
    });
  }

  loadStylesFromQueryString(styles) {
    const request = async () => {
      const path = getCompositeId();
      const response = await window.fetch(
        buildUrl(`${remoteServices.designs}/api/designs/${path}`, {
          api_version: ApiConstants.designs.legacyVersion
        })
      );
      const json = response.json();
      return json;
    };

    request().then(responseData => {
      const product = responseData.products[0];
      styles.push(product.styleId);
      const uniqueStyleIds = [...new Set(styles)];

      this.loadStylesWrapper(uniqueStyleIds, this.props);
    });
  }

  loadUploadFromQueryString(uploadParams) {
    this.props.getUploadFile(uploadParams).then(file => {
      this.props.upload({file, viewId: 1});
      this.props.hooks.setNavigateTo('/uploadProgress');
    });
  }

  isAllowedPathOnPageLoad() {
    for (const path of ALLOWED_ON_LOAD_PATHS) {
      if (matchPath(path, this.props.router.location.pathname)) {
        return true;
      }
    }

    return false;
  }

  showWelcome() {
    if (this.isAllowedPathOnPageLoad()) {
      return;
    }

    if (
      this.props.welcomeStage &&
      !import.meta.env.NDX_DISABLE_WELCOME &&
      !__DEVELOPMENT__
    ) {
      if (breakpoint(MediaQueries.mediumAndBelow) && designParamsPresent()) {
        if (showProductColorPresent()) {
          this.props.hooks.setNavigateTo('/productColor');
        } else {
          this.props.hooks.setNavigateTo('/');
        }
      } else {
        this.props.hooks.setNavigateTo(`/${this.props.welcomeStage}`);
      }
    }
  }

  render() {
    return (
      <PigmentThemeProvider>
        <div className="ndx-Content">
          <MediaQuery maxWidth={designTokens.breakpoints.md.value - 1}>
            {matches =>
              matches ? (
                <Suspense fallback={<div />}>
                  <App hooks={this.props.hooks} />
                </Suspense>
              ) : (
                <Suspense fallback={<div />}>
                  <App_Lg hooks={this.props.hooks} />
                </Suspense>
              )
            }
          </MediaQuery>
        </div>
        {this.props.isDragNDropAnywhereEnabled && <FullPageDropzone />}
        <EmbroideryModal
          open={this.state.isEmbroideryModalOpen}
          onClose={this.handleCloseEmbroideryModal}
        />
      </PigmentThemeProvider>
    );
  }
}

export default signal(mapSignalsToProps)(
  connect(select, actions)(withRouter(AppContainer))
);
